const translations = {
    application: 'Application',
    date: 'Date',
    duration: 'Duration',
    exportFailed: 'Failed to generate PDF report. Please try again.',
    exportPdf: 'Export PDF',
    location: 'Location',
    noFlightsToExport: 'Select flights to export.',
    pilot: 'Pilot',
    spray: 'Spray',
    spread: 'Spread',
    tooManyFlights: 'Maximum 500 flights can be exported at once.',
    unknown: 'Unknown'
};

export default translations;
